import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getIntegrationTypeName } from "@faire/retailer-visitor-shared/features/PointOfSale/utils/getIntegrationTypeName";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { TextArea } from "@faire/web--source/slate/Input/TextArea";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Modal } from "@faire/web--source/slate/Modal";
import { Radio } from "@faire/web--source/slate/Radio";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { createToast } from "@faire/web--source/slate/Toast/Toast";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { useQuery as useSurveyEntriesQuery } from "@faire/web-api--source/api/retailer-integrations-survey/get-hooks";
import { useMutation as useSurveyDataMutation } from "@faire/web-api--source/api/retailer-integrations-survey/post-hooks";
import { IRetailerIntegrationSurveyEntry } from "@faire/web-api--source/indigofair/retailer/IRetailerIntegrationSurveyEntry";
import { IUpdateRetailerIntegrationSurveyRequest } from "@faire/web-api--source/indigofair/retailer/IUpdateRetailerIntegrationSurveyRequest";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
export var SurveyModal = function(param) {
    var onClose = param.onClose;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(), 2), selectedIntegration = _useState[0], setSelectedIntegration = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), otherDescription = _useState1[0], setOtherDescription = _useState1[1];
    var isOtherSelected = selectedIntegration === IRetailerIntegrationSurveyEntry.IntegrationType.OTHER;
    var _useSurveyEntriesQuery = useSurveyEntriesQuery(), data = _useSurveyEntriesQuery.data, isPending = _useSurveyEntriesQuery.isPending;
    var _data_available_integration_types;
    var integrationTypes = (_data_available_integration_types = data === null || data === void 0 ? void 0 : data.available_integration_types) !== null && _data_available_integration_types !== void 0 ? _data_available_integration_types : [];
    useEffect(function() {
        var _data_previous_survey_entry, _data_previous_survey_entry1;
        setSelectedIntegration(data === null || data === void 0 ? void 0 : (_data_previous_survey_entry = data.previous_survey_entry) === null || _data_previous_survey_entry === void 0 ? void 0 : _data_previous_survey_entry.integration_type);
        var _data_previous_survey_entry_note;
        setOtherDescription((_data_previous_survey_entry_note = data === null || data === void 0 ? void 0 : (_data_previous_survey_entry1 = data.previous_survey_entry) === null || _data_previous_survey_entry1 === void 0 ? void 0 : _data_previous_survey_entry1.note) !== null && _data_previous_survey_entry_note !== void 0 ? _data_previous_survey_entry_note : "");
    }, [
        data
    ]);
    var _useSurveyDataMutation = useSurveyDataMutation({
        onSuccess: function() {
            createToast(strictLocalize({
                id: "ybIRhc",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Information received\u2014thank you!"
                    }
                ]
            }), {
                timeout: "medium"
            });
            onClose();
        }
    }), postSurveyData = _useSurveyDataMutation.mutate, isLoading = _useSurveyDataMutation.isPending;
    var handleSubmit = function() {
        if (!selectedIntegration) {
            return;
        }
        postSurveyData([
            IUpdateRetailerIntegrationSurveyRequest.build({
                survey_entry: {
                    integration_type: selectedIntegration,
                    note: isOtherSelected ? otherDescription : undefined
                }
            })
        ]);
    };
    return /*#__PURE__*/ _jsxs(Modal, {
        onClose: onClose,
        align: "stretch",
        width: "400px",
        height: "auto",
        padding: getSpacing("7x", "3x"),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "w6+fWU",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "What point-of-sale or inventory system do you use?"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            isPending ? /*#__PURE__*/ _jsx("div", {
                style: {
                    alignSelf: "center"
                },
                children: /*#__PURE__*/ _jsx(LoadingSpinner, {})
            }) : integrationTypes.map(function(type, index) {
                return /*#__PURE__*/ _jsxs(React.Fragment, {
                    children: [
                        index === 0 ? null : /*#__PURE__*/ _jsx(HorizontalLine, {}),
                        /*#__PURE__*/ _jsx(StyledRadio, {
                            label: getIntegrationTypeName(type, strictLocalize),
                            active: type === selectedIntegration,
                            onClick: function() {
                                return setSelectedIntegration(type);
                            }
                        })
                    ]
                }, index);
            }),
            isOtherSelected ? /*#__PURE__*/ _jsx(TextArea, {
                placeholder: strictLocalize({
                    id: "VPJdrg",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Add details here"
                        }
                    ]
                }),
                value: otherDescription,
                onChange: function(e) {
                    return setOtherDescription(e.target.value);
                },
                style: {
                    height: "80px"
                }
            }) : null,
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            /*#__PURE__*/ _jsx(Button, {
                onClick: handleSubmit,
                loading: isLoading,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "mWuNVF",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Submit"
                        }
                    ]
                })
            })
        ]
    });
};
var StyledRadio = styled(Radio).withConfig({
    componentId: "sc-357ad264-0"
})([
    "padding:",
    ";"
], getSpacing("3x", "2x"));
